import {Injectable} from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {AuthenticationService} from './user/authentication.service';
import {MessageService} from 'primeng/api';
import {catchError, tap} from "rxjs/operators";
import {error} from "protractor";

export const getToken = (transportDirection: string = null): any => {
    if (!localStorage.getItem('portalToken')) {
        return null;
    }
    return {token: localStorage.getItem('token'), sessionId: localStorage.getItem('sessionId')};
};

@Injectable()
export class TokenInterceptor implements HttpInterceptor {


    constructor(public auth: AuthenticationService, private router: Router, private messageService: MessageService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (localStorage.getItem("portalToken")) {
            var token = localStorage.getItem("portalToken");

            request = request.clone({
                setHeaders: {
                    'Authorization': 'Bearer ' + token,
                }
            });

            return next.handle(request).pipe(tap(response => {}, err => {
                let msg = err?.error?.message || JSON.parse(err?.error)?.message
                this.messageService.add({ key: 'tst', severity: 'error', summary: 'Hata', detail: msg });
            }))
        } else {
            request = request.clone({
            });
            return next.handle(request);
        }
    }

}

